const SOUNDS = {
  PLAYER_JOIN: "player-join.mp3",
  PLAYER_LEAVE: "player-leave.mp3",
  YOUR_TURN: "your-turn.mp3",
};

export const playSound = (soundName) => {
  try {
    const audio = new Audio(`/sounds/${soundName}`);
    audio.volume = 0.5;
    audio.play().catch((error) => {
      // Fallback: try player-join.mp3 for missing sounds
      if (soundName !== "player-join.mp3") {
        const fallback = new Audio("/sounds/player-join.mp3");
        fallback.volume = 0.3;
        fallback.play().catch(() => {});
      }
    });
  } catch (error) {
    console.error(`Erreur lors de la lecture du son ${soundName}:`, error);
  }
};

export default SOUNDS;
